import { useEffect, useState } from 'react';

interface Size {
  height: number;
  width: number;
}

export const useGetElementSize = (id: string, visibleOnly = false) => {
  const [size, setSize] = useState<Size>({ height: 0, width: 0 });

  useEffect(() => {
    const updateSize = () => {
      const el = document.querySelector(`#${id}`);
      if (!el) return;

      const rect = el.getBoundingClientRect();

      if (visibleOnly) {
        // Calculate visible area
        const viewHeight = window.innerHeight;
        const viewWidth = window.innerWidth;

        // Calculate how much of the element is visible
        const visibleTop = Math.max(0, rect.top);
        const visibleBottom = Math.min(viewHeight, rect.bottom);
        const visibleLeft = Math.max(0, rect.left);
        const visibleRight = Math.min(viewWidth, rect.right);

        // Set visible dimensions
        setSize({
          height: visibleBottom > visibleTop ? visibleBottom - visibleTop : 0,
          width: visibleRight > visibleLeft ? visibleRight - visibleLeft : 0,
        });
      } else {
        // Set total dimensions
        setSize({
          height: rect.height,
          width: rect.width,
        });
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    window.addEventListener('scroll', updateSize);
    return () => {
      window.removeEventListener('resize', updateSize);
      window.removeEventListener('scroll', updateSize);
    };
  }, [id, visibleOnly]);

  return size;
};
